import React from "react";
import { Box } from "grid-styled";
import _ from "lodash";

import { Divider, Heading, ElevatedBox } from "../globals";
import RecommendationListItem from "../RecommendationListItem";
import PurchaseLinks from "../PurchaseLinks";

const RecommendationList = ({ book }) => {
    const recommendations = _.orderBy(
        book.recommendations,
        [
            recommendation => recommendation.designer.firstName,
            recommendation => recommendation.designer.lastName
        ],
        ["asc", "asc"]
    );

    return (
        <div>
            <Divider />

            <ElevatedBox p={4}>
                <Heading is="h3" fontSize={5} lineHeight="1.5">
                    {`Why read ${book.title}?`}
                </Heading>

                {recommendations.map((recommendation, i) => (
                    <Box pt={8} key={recommendation.id}>
                        <RecommendationListItem
                            recommendation={recommendation}
                        />
                    </Box>
                ))}

                <Heading is="h3" fontSize={4} lineHeight="1.2" pt={8}>
                    Learn more
                </Heading>
                <Box pt={6}>
                    <PurchaseLinks book={book} />
                </Box>
            </ElevatedBox>
        </div>
    );
};

export default RecommendationList;



// WEBPACK FOOTER //
// ./src/components/RecommendationList/index.js